import { UserPermission, useUser } from "../requests/users";

export const hasOwnerPermission = (permissionLevel?: UserPermission): boolean =>
  permissionLevel !== undefined && permissionLevel === UserPermission.owner;

export const hasWritePermission = (permissionLevel?: UserPermission): boolean =>
  permissionLevel !== undefined &&
  [UserPermission.owner, UserPermission.write].includes(permissionLevel);

export const hasTrackPermission = (permissionLevel?: UserPermission): boolean =>
  permissionLevel !== undefined &&
  [UserPermission.owner, UserPermission.write, UserPermission.track].includes(permissionLevel);

export const hasReadPermission = (permissionLevel?: UserPermission): boolean =>
  permissionLevel !== undefined &&
  [UserPermission.owner, UserPermission.write, UserPermission.track, UserPermission.read].includes(
    permissionLevel
  );

export const hasNewTagPermission = hasWritePermission;

export const usePermissionLockAndMessage = (
  lockMessage: string,
  isLocked: boolean,
  minUserPermission?: UserPermission
): { permissionMessage: string; permissionLock: boolean } => {
  const user = useUser();
  let permissionMessage = lockMessage;
  let permissionLock = isLocked;
  if (minUserPermission === undefined || user?.permission_level_id === undefined) {
    return { permissionMessage, permissionLock };
  }

  if (minUserPermission === UserPermission.owner && !hasOwnerPermission(user.permission_level_id)) {
    return {
      permissionMessage: "You must have owner access to use feature.",
      permissionLock: true,
    };
  } else if (
    minUserPermission === UserPermission.write &&
    !hasWritePermission(user.permission_level_id)
  ) {
    return {
      permissionMessage: "You must have write access to use this feature.",
      permissionLock: true,
    };
  } else if (
    minUserPermission === UserPermission.track &&
    !hasTrackPermission(user.permission_level_id)
  ) {
    return {
      permissionMessage: "You must have edit access to use this feature.",
      permissionLock: true,
    };
  } else if (
    minUserPermission === UserPermission.read &&
    !hasReadPermission(user.permission_level_id)
  ) {
    return {
      permissionMessage: "You must have read access to use this feature.",
      permissionLock: true,
    };
  }

  return { permissionMessage, permissionLock };
};
